/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import * as React from 'react';

export interface RadioGroupContextValue {
  name: string;
  selectedValue: string;
  onGroupChange: (value: string) => void;
  disabled?: boolean;
}

const RadioGroupContext = React.createContext<RadioGroupContextValue | null>(null);

export default RadioGroupContext;
